import React, { useState } from "react";
import {
    PaymentElement,
    useStripe,
    useElements,
    AddressElement
} from "@stripe/react-stripe-js";
import './CheckoutForm.css';

export default function CheckoutForm({ sessionToken, payerEmail }) {
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [shippingAddress, setShippingAddress] = useState(null);

    const handleShippingChange = (event) => {
            const newAddress = event.value.address;
            setShippingAddress(newAddress);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (shippingAddress && Object.keys(shippingAddress).length > 0) {
            const requestBody = {
                paymentPayerEmail: payerEmail,
                paymentSessionToken: sessionToken,
                shipAddress: shippingAddress
            };

            try {
                await fetch("https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/Checkout/UpdateCheckoutFieldsShippingAddress", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestBody),
                });
            } catch (error) {
            }
        }

        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsLoading(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `https://www.victorylaneauthentication.com/orderConfirmation/${sessionToken}`
                //return_url: `https://localhost:3000/orderConfirmation/${sessionToken}`
            },
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
        } else {
            setMessage("An unexpected error occurred.");
        }

        setIsLoading(false);
    };

    const paymentElementOptions = {
        layout: "accordion"
    }

    return (
        <div className="checkout-form App">
            <form id="checkout-form-payment-form" onSubmit={handleSubmit}>
                <h2 className="checkout-form-title">Checkout</h2>

                <div className="checkout-form-address-wrapper">
                    <div className="checkout-form-payment-element-address">
                        <div className="address-element-label" style={{ fontWeight: "bold", fontSize: "1.1em" }}>Shipping Address</div>
                        <AddressElement options={{ mode: 'shipping' }} onChange={handleShippingChange}></AddressElement>
                    </div>
                    <div className="checkout-form-payment-element-address">
                        <div className="address-element-label" style={{ fontWeight: "bold", fontSize: "1.1em" }}>Billing Address</div>
                        <AddressElement options={{ mode: 'billing' }}></AddressElement>
                    </div>
                </div>
                <div id="checkout-form-payment-element" className="checkout-form-payment-element">
                    <PaymentElement id="payment-element" options={paymentElementOptions} />
                </div>
                <button
                    disabled={isLoading || !stripe || !elements}
                    id="checkout-form-submit-button"
                    className="checkout-form-submit-button">
                    <span id="checkout-form-button-text">
                        {isLoading ? (
                            <div className="checkout-form-spinner spinner" id="spinner" ></div>
                        ) : (
                            "Pay now"
                        )}
                    </span>
                </button>

                {message && (
                    <div id="checkout-form-payment-message" className="checkout-form-payment-message">
                        {message}
                    </div>
                )}
            </form>
        </div>
    );
}